import React, { useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import { store } from 'Store/store.index';
import { PayContext } from './ContextProvider';
import LeftTip from './LeftTip';
import EduLeftTip from './EduLeftTip';
// import PayFormChoosePlan from './PayFormChoosePlan';
// import PayFormBillingInformation from './PayFormBillingInformation';
// import PayFormPaymentInformation from './PayFormPaymentInformation';
// import PayFormSubmitFooter from './PayFormSubmitFooter';
import PayResSuccess from './PayResSuccess';
import PayResFail from './PayResFail';
import './PaymentDlg.scss';
import intl from 'react-intl-universal';
import dayjs from 'dayjs';
// import { Elements } from '@stripe/react-stripe-js';
// import { loadStripe } from '@stripe/stripe-js';
import _remove from 'lodash/remove';
import { paymentApi } from '@/api';
import {
  getCurrencySymbol,
  isCommonFeatureDomain,
  isPdfOnlineDomain,
} from 'Utils/utils';
import _isEmpty from 'lodash/isEmpty';

let pk = '';
if (window.phantomOnlineGlobalConfig && 'stripePubSecret' in
  window.phantomOnlineGlobalConfig) {
  pk = window.phantomOnlineGlobalConfig.stripePubSecret;
}
if (!pk) {
  if (isPdfOnlineDomain() || isCommonFeatureDomain()) {
    pk = 'pk_live_ikzi7o3EVk6Wr2q6s81KfRQV';
  } else {
    pk = 'pk_test_YoEEzh7xiHbrO1qhOv4hhWcT';
  }
}
// const stripePromise = loadStripe(pk);

const PaymentDialog = props => {
  if (!store.userStore.userInfo) {
    return null;
  }

  const { show, isFree, isEduBuy, eduBuyParam } = props;
  const { close } = props;

  const Processing = intl.formatMessage({ id: 'account.Processing' });
  // const ConfirmTip = intl.formatMessage({ id: 'account.ConfirmTip' });

  // const [countryList, setCountryList] = useState([]);
  // const [currencyList, setCurrencyList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const [paySuccess, setPaySuccess] = useState(false);
  const [errList, setErrList] = useState([]);
  const { userEmail, company, firstname, lastname } = store.userStore.userInfo;
  const [formKey, setFormKey] = useState({
    currency: '',// 币种
    planType: 'yearly',
    planPrice: 0,
    firstName: firstname,
    lastName: lastname,
    email: userEmail,
    nameLicense: '',
    country: '',
    isEuCountry: false,
    province: '',// state / province
    city: '',
    address: '',
    zip: '',
    abn: '', // abnnumber
    vat: '', // vatnumber
    company: company,
    card: '',
    cardHolderName: '',
    isNewCard: false,
    holderName: '',
    check: true,
  });

  const removeFromErrList = k => {
    if (errList.includes(k)) {
      let updateErrList = errList;
      _remove(updateErrList, (n) => n === k);
      setErrList(updateErrList);
    }
  };

  const setFormKeyValue = (k, v) => {
    setFormKey(old => ({ ...old, [k]: v }));
    removeFromErrList(k);
  };

  const lastSevenDay = dayjs().add(7, 'd').format('YYYY-MM-DD');
  const ProviderValue = {
    isFree,
    store,
    setLoading,
    setPaySuccess,
    setIsPaying,
    close,
    lastSevenDay,
    formKey,
    setFormKeyValue,
    errList,
    setErrList,
    removeFromErrList,
    isPaying,
    isEduBuy,
    eduBuyParam,
  };

  useEffect(() => {
    const fetchCurrency = async () => {
      const { userSubStripeId } = store.accountStore;
      const email = userSubStripeId ? userEmail : '';
      const res = await paymentApi.getCurrency(store.userStore.token, email);
      let updateList = [];
      let updateSelCurrency = '';

      if (res.ret === 200 && res.message.toLowerCase() === 'success') {
        updateSelCurrency = res.data.default.code;
        updateList = Object.values(res.data.list);
        updateList.forEach(i => {
          i.labelValue = i.currency_code;
          i.label = i.currency_name;
          i.currency_symbol = getCurrencySymbol(i.currency_code,
            i.currency_symbol);
        });
      }
      setFormKeyValue('currency', updateSelCurrency);
      setCurrencyList(updateList);
    };
    const fetchCountry = async () => {
      let updateList = [];
      let updateSelCountry = '';
      const res = await paymentApi.getCountry(store.userStore.token);
      if (res.ret === 200 && res.message.toLowerCase() === 'success') {
        updateSelCountry = res.data.default.country;
        updateList = Object.values(res.data.list);
        updateList.forEach(i => {
          i.labelValue = i.code;
          i.label = i.name;
        });
      }
      setFormKeyValue('country', updateSelCountry);
      setCountryList(updateList);
    };

    const fn = async () => {
      await fetchCurrency();
      await fetchCountry();
    };

    fn();
  }, []);

  useEffect(() => {
    if (isEduBuy && !_isEmpty(eduBuyParam)) {
      const { country, license, licensePrice, licenseCurrency, isEuCountry } = eduBuyParam;
      setFormKeyValue('currency', licenseCurrency);
      setFormKeyValue('planType', license);
      setFormKeyValue('planPrice', licensePrice);
      setFormKeyValue('country', country);
      setFormKeyValue('isEuCountry', isEuCountry);
    }
  }, [isEduBuy, eduBuyParam]);

  return (
    <Modal
      width={1030}
      visible={show}
      footer={null}
      maskClosable={false}
      wrapClassName='pay-plan-dialog'
      onCancel={() => {
        close();
        if (isPaying && paySuccess) {
          store.accountStore.getSubscribeStateNow();
        }
      }}
    >
      <PayContext.Provider value={ProviderValue}>
        <Spin tip={Processing}
              spinning={loading}
              wrapperClassName={`pay-loading ${isPaying ? 'on' : ''}`}
              size='large'>
          <div className='pay-main-box'>
            <div className='left'>
              {isEduBuy ? <EduLeftTip detail={eduBuyParam} /> : <LeftTip />}
            </div>
            <div className={`right ${isEduBuy ? 'edu' : ''}`}>
              {/* <Elements stripe={stripePromise}>
                {isEduBuy ? <p className='confirm-tip'>{ConfirmTip}</p> : <PayFormChoosePlan currencyList={currencyList} />}
                <PayFormBillingInformation countryList={countryList} />
                <PayFormPaymentInformation />
                <PayFormSubmitFooter />
              </Elements> */}
            </div>
          </div>
          {isPaying && paySuccess && (<PayResSuccess />)}
          {isPaying && !paySuccess && (<PayResFail />)}
        </Spin>
      </PayContext.Provider>
    </Modal>
  );
};
export default PaymentDialog;